import { render } from "./EditItem.vue?vue&type=template&id=a27b8650&scoped=true"
import script from "./EditItem.vue?vue&type=script&lang=js"
export * from "./EditItem.vue?vue&type=script&lang=js"

import "./EditItem.vue?vue&type=style&index=0&id=a27b8650&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a27b8650"]])

export default __exports__